import React, { useContext, useEffect } from 'react'
import LanguageSwitch from '@/components/LanguageSwitch'

import LogoText from '@/assets/logoText.svg'

import styles from './style/index.module.less'
import LoginBanner from '../login/banner'
import RegisterContent from './register-content'
import { Space } from '@arco-design/web-react'
import useLocale from '@/utils/useLocale'
import Link from 'next/link'

function Register() {
  const t = useLocale()

  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light')
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <LogoText />
        <div className={styles['logo-text']}></div>
      </div>
      <div className={styles.banner}>
        <div className={styles['banner-inner']}>
          <LoginBanner />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <Space size={24}>
            <Link href="/board">
              <a className={styles.headerLink}>{t['register.home']}</a>
            </Link>
            <Link href="/login">
              <a className={styles.headerLink}>{t['register.login']}</a>
            </Link>
          </Space>
          <LanguageSwitch theme="light" />
        </div>
        <div className={styles['content-inner']}>
          <RegisterContent />
        </div>
      </div>
    </div>
  )
}
Register.displayName = 'RegisterPage'

export default Register
